import React from 'react';
import { Switch } from 'antd';
import { C } from '../../constants/design-tokens';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import { palette } from '@doer/frontend-components/theme';

interface SubtitlesSelectorProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Switch para activar/desactivar la generación de subtítulos automáticos.
 */
export const SubtitlesSelector: React.FC<SubtitlesSelectorProps> = ({ checked, onChange }) => {
  const { spacing, fontSize } = useResponsiveSizes();

  return (
    <div
      style={{
        marginBottom: spacing.lg,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span
          style={{
            fontSize: fontSize.sm,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: 0.6,
            color: C.textLabel
          }}
        >
          Subtítulos
        </span>
      </div>
      <Switch
        checked={checked}
        onChange={onChange}
        checkedChildren='ON'
        unCheckedChildren='OFF'
        style={{
          backgroundColor: checked ? palette.primitives.purple.purple400 : palette.primitives.purple.purple75
        }}
      />
    </div>
  );
};
